import request from "root/js/request";

const getCancellationTableOzon = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  delivery_type,
  delivery_type__in,
  ordering,
  offset,
  limit,
  group_by,
  q,
  offer_id__icontains,
  sku__icontains,
}) => {
  const response = await request({
    url: "/ozon_analytics/posting_cancellation_table/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      delivery_type,
      delivery_type__in,
      ordering,
      group_by,
      offset,
      limit,
      q,
      offer_id__icontains,
      sku__icontains,
    },
  });
  return response.data;
};

export { getCancellationTableOzon };
